<template>
  <div class="artwork" :class="classArtwork">
    <div class="artwork__bg-color"></div>
    <div class="artwork__inner" ref="inner" :class="classesInner" v-if="content">
      <div class="artwork__bg">
        <div class="artwork__bg-image" ref="img_background">
          <img v-if="oeuvre2" :src="oeuvre2" :alt="`${ content.title} - ${ content.artiste}`">
        </div>
      </div>

      <div class="artwork__content">
        <div class="artwork__col artwork__col--infos artwork__col--mobile-only">
          <div class="infos" ref="infos">
            <p class="infos__author" v-if="content.artiste">{{ content.artiste}}</p>
          </div>
        </div>

        <div class="artwork__col artwork__col--oeuvre" ref="img_oeuvre">
          <!--  infos show only on single-plant page on desktop-->
          <div v-show="!isHome" class="infos" ref="infos">
            <div class="infos__top">
              <p class="infos__name" v-if="content.title">{{ content.title}}</p>
              <p class="infos__author" v-if="content.artiste">{{ content.artiste}}</p>
            </div>
            <p class="infos__credits" v-if="content.credits">{{ content.credits}} <span v-if="content.date">– {{ content.date}}</span></p>
            <p class="infos__credits" v-if="!content.credits && content.date">{{ content.date}}</p>
          </div>
          <!-- <div class="artwork__shadow-oeuvre"></div> -->
          <div class="oeuvre-container">
            <img class="oeuvre-img--desktop" v-if="oeuvre1" :src="oeuvre1" :alt="`${ content.title} - ${ content.artiste}`">
            <img v-show="isHome" class="oeuvre-img--mobile" src="/static/assets/img/jardins_small.png" alt="">
          </div>
        </div>

        <div class="artwork__col artwork__col--infos">
          <!--  infos show only single plant page on mobile & on home page-->
          <div class="infos" ref="infos">
            <p class="infos__name" v-if="content.title">{{ content.title}}</p>
            <p class="infos__author" v-if="content.artiste">{{ content.artiste}}</p>
            <p class="infos__credits" v-if="content.credits">{{ content.credits}} <span v-if="content.date">– {{ content.date}}</span></p>
            <p class="infos__credits" v-if="!content.credits && content.date">{{ content.date}}</p>
          </div>

          <div class="promo">
            <div v-show="!isHome" class="promo__logo-jardins">
              <img src="/static/assets/img/jardins_small.png" alt="">
            </div>
            <p v-if="!isHome" class="promo__text">Retrouvez cette plante dans l’expo Jardins au Grand Palais jusqu’au 24 juillet 2017 et visitez là autrement avec le parcours botanique de l’application !</p>
            <p v-else class="promo__text">Miroir du monde, le jardin rend compte d'une manière de voir la nature, de la mettre en scène et de la penser.</p>
            <a href="http://www.grandpalais.fr/fr/article/jardins-lapplication-mobile-de-lexposition" target="_blank" class="promo__btn" @mouseenter="onMouseEnter()">
              <i class="smartphone"></i>
              <span>Découvrez l’appli de l’exposition</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'styles/components/artwork.styl'
import Detector from 'utils/Detector'
import Emitter from 'core/Emitter'
import * as PIXI from 'pixi.js'
import TweenMax from 'gsap'

export default {
  name: 'artwork',
  data () {
    return {
      innerIsHidden: false,
      content: null,
      oeuvre1: null,
      oeuvre2: null,
      isHome: null
    }
  },
  props: [
    'prefix',
    'oeuvre'
  ],
  computed: {
    imgExtension () {
      return (this.oeuvre.transparent) ? '.png' : '.jpg'
    },

    classesInner () {
      let c = {}
      c['artwork__inner--is-hidden'] = this.innerIsHidden

      return c
    },
    classesContent () {
      let c = {}
      c['artwork__content--home'] = this.isHome
      c['artwork__content'] = true

      return c
    },
    classArtwork () {
      let c = {}
      c['artwork--home'] = this.isHome
      return c
    }
    // classes () {
    //   let c = {}
    //   c[`nav__btn--${this.direction}`] = true
    //
    //   return c
    // }
  },

  watch: {
    // call again the method if the route changes
    'prefix': 'updateArtwork'
  },

  mounted () {
    this.addListeners()
    this.isHome = this.$route.name === 'home'
    this.updateArtwork()
  },
  beforeDestroy () {
    if (this.timeoutUpdate) {
      window.clearTimeout(this.timeoutUpdate)
      this.timeoutUpdate = null
    }
    if (this.loader) {
      this.loader.reset()
    }
    this.removeListeners()
  },
  methods: {
    bindAll () {
      ['resize']
          .forEach((fn) => (this[fn] = this[fn].bind(this)))
    },

    loadAssets () {
      this.$nextTick(() => {
        // eslint-disable-next-line new-cap
        if (!this.loader) {
          this.loader = new PIXI.loaders.Loader()
        }
        this.loader.reset()
        // console.log(`/static/assets/img/plantes/${this.prefix}/${this.prefix}_Oeuvre_01${this.imgExtension}`)
        if (this.isHome) {
          this.loader.add('oeuvre_1', `/static/assets/img/logo_jardin.png`)
          this.loader.add('oeuvre_2', `/static/assets/img/plantes/13_Souci/13_Souci_Oeuvre_02.jpg`)
          this.content = {
            artiste: '15 MARS - 24 JUILLET 2017',
            title: 'GRAND PALAIS'
          }
        } else {
          this.loader.add('oeuvre_1', `/static/assets/img/plantes/${this.prefix}/${this.prefix}_Oeuvre_01${this.imgExtension}`)
          this.loader.add('oeuvre_2', `/static/assets/img/plantes/${this.prefix}/${this.prefix}_Oeuvre_02.jpg`)
        }

        this.loader.load((loader, resources) => {
          this.oeuvre1 = resources['oeuvre_1'].url
          this.oeuvre2 = resources['oeuvre_2'].url

          this.content = this.isHome ? this.content : this.oeuvre

          setTimeout(() => {
            this.init()
          }, 50)
        })
      })
    },

    init () {
      // this.updateArtwork()
      this.animate()
    },

    updateArtwork () {
      // this.tlHide
      // .to(this.$refs.inner, 0.8, {
      //   autoAlpha: 0,
      //   ease: Expo.easeOut
      // }, 'start')
      // .add(() => {
      //   this.loadAssets()
      // }, '+=1')

      this.innerIsHidden = true

      if (this.timeoutUpdate) {
        window.clearTimeout(this.timeoutUpdate)
        this.timeoutUpdate = null
      }

      let delay = (this.isHome) ? 0 : 2500
      this.timeoutUpdate = setTimeout(() => {
        this.loadAssets()
      }, delay)
    },

    animate () {
      this.innerIsHidden = false

      this.$nextTick(() => {
        let size = Detector.getScreenSize()
        this.resize(size)
        if (this.$parent.resizeScroll) {
          this.$parent.resizeScroll()
        } else if (this.$parent.$parent.resize) {
          this.$parent.$parent.resize({size})
        }
      })
      // if (this.tlShow) {
      //   this.tlShow.kill()
      // }
      //
      // this.tlShow = new TimelineMax()
      // this.tlShow
      // .to(this.$refs.inner, 0.8, {
      //   autoAlpha: 1,
      //   ease: Quint.easeOut
      // }, 'start')
      // .from(this.$refs.img_background, 0.8, {
      //   autoAlpha: 0,
      //   ease: Quint.easeOut
      // }, 'start')
      // .from(this.$refs.img_oeuvre, 1.25, {
      //   autoAlpha: 0,
      //   rotation: 6,
      //   y: 40,
      //   x: -60,
      //   scale: 0.95,
      //   ease: Expo.easeOut
      // }, 'start+=0.3')
      // .staggerFrom(this.$refs.infos.children, 0.8, {
      //   autoAlpha: 0,
      //   y: 20,
      //   ease: Quint.easeOut
      // }, 0.05, 'start+=0.4')
    },
    onMouseEnter () {
      Emitter.emit('SOUND::PLAY_UI_CLICK')
    },
    resize (size) {
      this.size = size
      this.$el.style.minHeight = `${this.size.h * 0.8}px`
    },

    addListeners () {
      Emitter.on('RESIZE', this.resize)
    },

    removeListeners () {
      Emitter.removeListener('RESIZE', this.resize)
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** index.vue?33846367
 **/